export default function() {
    var bodyToggles = document.querySelectorAll('[data-toggle-body]');
    var bodyToggleClass;
    for (var i = 0; i < bodyToggles.length; i++) {
      bodyToggles[i].addEventListener('click', function (e) {
        e.preventDefault();
        if (e.target.hasAttribute('data-toggle-body')) {
          bodyToggleClass = e.target.getAttribute('data-toggle-body');
        } else if (e.target.parentNode.hasAttribute('data-toggle-body')) {
          bodyToggleClass = e.target.parentNode.getAttribute('data-toggle-body');
        }
        document.body.classList.toggle(bodyToggleClass);
        if (bodyToggleClass == 'bodyToggleSearch' && document.body.classList.contains(bodyToggleClass)) {
          document.querySelector('.toggleSearch input[type="text"]').focus();
        }
      })
    }
}
